// KL guide: condo aircond servicing.
const content = {
    slug: 'condo-aircond-servicing-guide',
    title: 'Condo Aircond Servicing in KL | Management Rules, Ledges, Access',
    description: 'Servicing aircond in a KL condo: contractor registration, working hours, safe access to compressor ledges, and how to prepare so the visit goes smoothly.',
    eyebrow: 'KL · Aircond guide',
    h1: 'Servicing Aircond in a KL Condo: What to Know',
    lead: 'Condo aircond servicing comes with extra steps: management approval, contractor hours, parking for the technician and that awkward outdoor unit on the ledge. A little preparation saves a wasted trip.',
    datePublished: '2026-10-03',
    image: 'blog/living/aircon-condenser.jpg',
    imageAlt: 'Aircond outdoor unit on a condo ledge',
    summary: {
        title: 'Checklist',
        items: [
            'Check your condo\'s contractor rules and working hours.',
            'Register the technician with management or the guardhouse if required.',
            'Arrange visitor parking or loading bay access.',
            'Clear access to the compressor ledge or service balcony.',
        ],
    },
    sections: [
        {
            title: 'Management and house rules',
            paragraphs: [
                'Most condos set house rules for contractors through their management body - typically allowed working hours (often weekdays and Saturday mornings), registration at the guardhouse, and sometimes a contractor form signed by the owner or tenant. Some ask for the technician\'s IC in advance.',
                'Tell us your condo name when you book. We share the technician\'s details so registration is quick, and we schedule within the allowed hours.',
            ],
        },
        {
            title: 'The compressor ledge',
            cards: [
                { title: 'Safe access first', body: 'Outdoor units on ledges are a fall risk. Our technicians only work on ledges that can be reached safely; if a ledge needs a harness point or rope access, we tell you.' },
                { title: 'Keep the ledge clear', body: 'Plants, laundry racks and stored items block airflow and access. Clear them before the visit.' },
                { title: 'Service balconies', body: 'Units on a service balcony or AC bay are easy to reach - mention it when you book.' },
            ],
        },
        {
            title: 'Protecting the unit below',
            paragraphs: [
                'Water from a chemical wash is collected in a wash bag, not poured down the facade. Blocked drain pipes in condos can leak into the unit below, so the technician also flushes the drain.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Can aircond be serviced on Sunday in a condo?',
            answer: 'Many condos don\'t allow contractor work on Sundays or public holidays. Check your house rules - we will book within them.',
        },
        {
            question: 'Who is responsible for a leak into the unit below?',
            answer: 'Usually the owner of the leaking unit. Regular drain flushing during servicing is the best prevention.',
        },
    ],
    cta: {
        title: 'Book a condo-ready service',
        body: (c) => `General service from ${c.money(c.tables.general[0].wall)} per unit - we handle the registration details with your management.`,
        href: '/my/aircond-service-kuala-lumpur/aircond-general-service',
        label: 'See general service',
    },
}

export default content
